
window.NQShopify = {
  currentCategory: 'ALL',
  cartData: null,

  init: function() {
    this.refreshCart();
    this.setupFilters();
    this.setupSearch();
    this.setupSort();
  },

  openCartDrawer: function() {
    this.refreshCart();
    var drawer = document.getElementById('nqCartDrawer');
    var backdrop = document.getElementById('nqCartDrawerBackdrop');
    if (drawer) drawer.classList.add('active');
    if (backdrop) backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
  },

  closeCartDrawer: function() {
    var drawer = document.getElementById('nqCartDrawer');
    var backdrop = document.getElementById('nqCartDrawerBackdrop');
    if (drawer) drawer.classList.remove('active');
    if (backdrop) backdrop.classList.remove('active');
    document.body.style.overflow = '';
  },

  buyNow: function(variantId) {
    var self = this;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) {
          alert('Ten pakiet jest obecnie wyprzedany lub niedostępny (stan magazynowy: 0 szt.). Ustaw stan w panelu Shopify.');
          throw err;
        });
      }
      return res.json();
    })
    .then(function() {
      self.openCartDrawer();
    })
    .catch(function(err) {
      console.error('buyNow error:', err);
    });
  },

  addToCart: function(variantId, btn) {
    var self = this;
    if (btn) {
      btn.style.opacity = '0.5';
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) {
          alert('Ten pakiet jest obecnie wyprzedany lub niedostępny (stan magazynowy: 0 szt.). Ustaw stan w panelu Shopify.');
          throw err;
        });
      }
      return res.json();
    })
    .then(function() {
      if (btn) {
        btn.style.opacity = '1';
        btn.disabled = false;
      }
      self.openCartDrawer();
    })
    .catch(function(err) {
      console.error('addToCart error:', err);
      if (btn) {
        btn.style.opacity = '1';
        btn.disabled = false;
      }
    });
  },

  
  addToCartAndReturnHome: function(variantId, btn) {
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.7';
      btn.textContent = 'Dodawanie do koszyka...';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function() {
      window.location.href = '/?cart=1';
    })
    .catch(function(err) {
      console.error('Error adding to cart:', err);
      window.location.href = '/?cart=1';
    });
  },
changeQuantity: function(key, quantity) {
    var self = this;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      self.refreshCart();
    });
  },

  refreshCart: function() {
    var self = this;
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        self.cartData = cart;
        self.renderCart(cart);
      })
      .catch(function(err) { console.error('Cart refresh err:', err); });
  },

  renderCart: function(cart) {
    var badges = document.querySelectorAll('.cart-count-badge, #cartDrawerCountBadge');
    badges.forEach(function(b) {
      b.textContent = cart.item_count || 0;
    });

    var itemsContainer = document.getElementById('cartDrawerItems');
    var totalEl = document.getElementById('cartDrawerTotalPrice');
    var footerEl = document.getElementById('cartDrawerFooter');
    if (!itemsContainer) return;

    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="cart-empty-state"><div style="font-size: 2.5rem;">📦</div><p>Twój koszyk jest pusty.</p><button type="button" class="btn-drawer-continue" onclick="NQShopify.closeCartDrawer(); var k = document.getElementById(\'katalog\'); if(k) k.scrollIntoView({behavior:\'smooth\'});">Wybierz pakiet z katalogu</button></div>';
      if (totalEl) totalEl.textContent = '0 zł';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';
    var totalZl = Math.round(cart.total_price / 100);
    if (totalEl) totalEl.textContent = totalZl + ' zł';

    var html = '';
    cart.items.forEach(function(item) {
      var itemPriceZl = Math.round(item.final_price / 100);
      var img = item.image ? item.image : '';
      html += '<div class="cart-item-card">';
      if (img) {
        html += '<img src="' + img + '" alt="' + item.title + '" class="cart-item-img">';
      }
      html += '<div class="cart-item-details">';
      html += '<div class="cart-item-title">' + item.product_title + '</div>';
      html += '<div class="cart-item-price">' + itemPriceZl + ' zł</div>';
      html += '<div class="cart-item-qty-row">';
      html += '<button type="button" class="btn-qty" onclick="NQShopify.changeQuantity(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>';
      html += '<span class="qty-val">' + item.quantity + ' szt.</span>';
      html += '<button type="button" class="btn-qty" onclick="NQShopify.changeQuantity(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
      html += '<button type="button" class="btn-remove-item" onclick="NQShopify.changeQuantity(\'' + item.key + '\', 0)" title="Usuń pakiet">✕</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    itemsContainer.innerHTML = html;
  },

  filterCategory: function(cat) {
    this.currentCategory = cat;
    document.querySelectorAll('.tab-btn').forEach(function(btn) {
      if (btn.getAttribute('data-cat') === cat) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    var cards = document.querySelectorAll('.lot-card');
    cards.forEach(function(card) {
      var cardCat = (card.getAttribute('data-cat') || '').toUpperCase();
      var show = (cat === 'ALL' || cardCat === cat);
      if (show) {
        card.classList.remove('is-hidden');
        card.style.display = 'flex';
      } else {
        card.classList.add('is-hidden');
        card.style.setProperty('display', 'none', 'important');
      }
    });
  },

  setupFilters: function() {
    var self = this;
    document.querySelectorAll('.tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = this.getAttribute('data-cat');
        self.filterCategory(cat);
      });
    });
  },

  setupSearch: function() {
    var self = this;
    var searchInput = document.getElementById('catalogSearch');
    if (!searchInput) return;
    searchInput.addEventListener('input', function(e) {
      var query = e.target.value.toLowerCase().trim();
      var cards = document.querySelectorAll('.lot-card');
      cards.forEach(function(card) {
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var cardCat = (card.getAttribute('data-cat') || '').toUpperCase();
        var matchesCat = (self.currentCategory === 'ALL' || cardCat === self.currentCategory);
        var matchesQuery = (!query || title.indexOf(query) !== -1 || cardCat.toLowerCase().indexOf(query) !== -1);
        
        if (matchesCat && matchesQuery) {
          card.classList.remove('is-hidden');
          card.style.display = 'flex';
        } else {
          card.classList.add('is-hidden');
          card.style.setProperty('display', 'none', 'important');
        }
      });
    });
  },

  setupSort: function() {
    var sortSelect = document.getElementById('catalogSort');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function(e) {
      var val = e.target.value;
      var grid = document.getElementById('productsGrid');
      if (!grid) return;
      var cards = Array.from(grid.querySelectorAll('.lot-card'));
      cards.sort(function(a, b) {
        var priceA = parseFloat(a.getAttribute('data-price') || 0);
        var priceB = parseFloat(b.getAttribute('data-price') || 0);
        var pairA = parseFloat(a.getAttribute('data-pair') || 0);
        var pairB = parseFloat(b.getAttribute('data-pair') || 0);
        var countA = parseInt(a.getAttribute('data-pairs-count') || 0);
        var countB = parseInt(b.getAttribute('data-pairs-count') || 0);

        if (val === 'price_asc') return priceA - priceB;
        if (val === 'price_desc') return priceB - priceA;
        if (val === 'pair_asc') return pairA - pairB;
        if (val === 'pairs_count_desc') return countB - countA;
        return 0;
      });
      cards.forEach(function(c) { grid.appendChild(c); });
    });
  },

  
  scrollReviews: function(dir) {
    var track = document.getElementById('reviewsTrack');
    if (!track) return;
    var scrollAmount = 340;
    if (dir === 'prev') {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  },
openLightbox: function(imgSrc, title, productUrl) {
    var modal = document.getElementById('imageLightboxModal');
    var img = document.getElementById('lightboxImg');
    var titleEl = document.getElementById('lightboxTitle');
    var linkEl = document.getElementById('lightboxProductLink');
    if (modal && img) {
      img.src = imgSrc;
      if (titleEl) titleEl.textContent = title || '';
      if (linkEl && productUrl) {
        linkEl.href = productUrl;
        linkEl.style.display = 'inline-flex';
      }
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  },

  closeLightbox: function(e) {
    if (e && e.target && e.target.closest && e.target.closest('.lightbox-image-container')) {
      return;
    }
    var modal = document.getElementById('imageLightboxModal');
    if (modal) {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
  },

  copyText: function(text, btn) {
    navigator.clipboard.writeText(text).then(function() {
      var orig = btn.innerHTML;
      btn.innerHTML = '<span style="color:#22c55e">Skopiowano!</span>';
      setTimeout(function() { btn.innerHTML = orig; }, 2000);
    });
  }
};

function initNQ() {
  NQShopify.init();
  if (window.location.search.indexOf("cart=1") !== -1) { NQShopify.openCartDrawer(); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNQ);
} else {
  initNQ();
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    NQShopify.closeLightbox();
    NQShopify.closeCartDrawer();
  }
});


/* ==========================================================================
   NQ HURTOWNIA - COOKIE CONSENT MANAGER (RODO & SHOPIFY PRIVACY)
   ========================================================================== */
window.NQCookieConsent = {
  storageKey: 'nq_cookie_consent_v1',

  init: function() {
    var consent = this.getConsent();
    if (!consent) {
      setTimeout(function() {
        var banner = document.getElementById('nqCookieBanner');
        if (banner) banner.style.display = 'block';
      }, 500);
    } else {
      this.applyConsent(consent);
    }
  },

  getConsent: function() {
    try {
      var item = localStorage.getItem(this.storageKey);
      return item ? JSON.parse(item) : null;
    } catch (e) {
      return null;
    }
  },

  saveConsent: function(consentObj) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(consentObj));
    } catch (e) {}
    this.applyConsent(consentObj);
    this.hideBanner();
    this.closeModal();
  },

  applyConsent: function(consent) {
    // Notify Shopify Customer Privacy API if present
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      try {
        var tracking = !!(consent.analytics || consent.marketing);
        window.Shopify.customerPrivacy.setTrackingConsent(tracking, function() {});
      } catch (e) {}
    }
    // Update modal checkboxes to reflect current state
    var aToggle = document.getElementById('cookieAnalyticsToggle');
    var mToggle = document.getElementById('cookieMarketingToggle');
    if (aToggle) aToggle.checked = !!consent.analytics;
    if (mToggle) mToggle.checked = !!consent.marketing;
  },

  acceptAll: function() {
    this.saveConsent({
      essential: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    });
  },

  rejectOptional: function() {
    this.saveConsent({
      essential: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    });
  },

  saveCustom: function() {
    var aToggle = document.getElementById('cookieAnalyticsToggle');
    var mToggle = document.getElementById('cookieMarketingToggle');
    this.saveConsent({
      essential: true,
      analytics: aToggle ? aToggle.checked : false,
      marketing: mToggle ? mToggle.checked : false,
      timestamp: new Date().toISOString()
    });
  },

  hideBanner: function() {
    var banner = document.getElementById('nqCookieBanner');
    if (banner) banner.style.display = 'none';
  },

  openBanner: function() {
    var banner = document.getElementById('nqCookieBanner');
    if (banner) banner.style.display = 'block';
  },

  openModal: function() {
    var modal = document.getElementById('nqCookieModal');
    var backdrop = document.getElementById('nqCookieModalBackdrop');
    var consent = this.getConsent() || { analytics: false, marketing: false };
    
    var aToggle = document.getElementById('cookieAnalyticsToggle');
    var mToggle = document.getElementById('cookieMarketingToggle');
    if (aToggle) aToggle.checked = !!consent.analytics;
    if (mToggle) mToggle.checked = !!consent.marketing;

    if (modal) {
      modal.style.display = 'flex';
      modal.classList.add('active');
    }
    if (backdrop) backdrop.classList.add('active');
  },

  closeModal: function() {
    var modal = document.getElementById('nqCookieModal');
    var backdrop = document.getElementById('nqCookieModalBackdrop');
    if (modal) {
      modal.classList.remove('active');
      modal.style.display = 'none';
    }
    if (backdrop) backdrop.classList.remove('active');
  }
};

// Auto-init cookie consent
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { NQCookieConsent.init(); });
} else {
  NQCookieConsent.init();
}
